import React from "react";

import { CustomerCardPage, DataVerificationCompany, PackagesToSignPage, PolicyHolderList } from "@/components/features";
import { fakeI18n } from "@/i18n";
import { AppRoute, Identity, Permissions, RouteItem } from "@/shared/domain";
import { Scope } from "@/shared/hooks/useAuth/types";

const CommunicationSalaryPage = React.lazy(
    () => import("../components/features/ToDos/CommunicationSalaryPage/CommunicationSalaryPage"),
);
const LiabilityPage = React.lazy(() => import("../components/features/ToDos/LiabilityPage/LiabilityPage"));
export const toDoRoutes = (user: Identity): RouteItem[] => {
    return [
        {
            path: AppRoute.Liability,
            element: <PolicyHolderList />,
            breadcrumb: fakeI18n.t("Breadcrumbs.Liability"),
            denyScopes: [Scope.Preview],
        },
        {
            path: AppRoute.CustomerCard,
            element: <PolicyHolderList />,
            breadcrumb: fakeI18n.t("Breadcrumbs.CustomerCard"),
            denyScopes: [Scope.Preview],
        },
        {
            path: AppRoute.CommunicationSalary,
            element: <PolicyHolderList />,
            breadcrumb: fakeI18n.t("Breadcrumbs.CommunicationSalary"),
            denyScopes: [Scope.Preview],
        },
        ...(user.hasGlobalPermission(Permissions.DeclareLiability10)
            ? [
                  {
                      path: AppRoute.LiabilityDetail,
                      element: <LiabilityPage />,
                      denyScopes: [Scope.Preview],
                  },
              ]
            : []),
        ...(user.hasGlobalPermission(Permissions.CommunicateSalary)
            ? [
                  {
                      path: AppRoute.CommunicationSalaryDetail,
                      element: <CommunicationSalaryPage />,
                      denyScopes: [Scope.Preview],
                  },
              ]
            : []),
        ...(user.hasGlobalPermission(Permissions.AccessCustomerForm)
            ? [
                  {
                      path: AppRoute.CustomerCardDetail,
                      element: <CustomerCardPage />,
                      denyScopes: [Scope.Preview],
                  },
              ]
            : []),
        {
            path: AppRoute.PackagesToSign,
            element: <PackagesToSignPage />,
            breadcrumb: fakeI18n.t("BreadCrumbs.Pages_Documentstosign"),
            allowScopes: [Scope.SignPackages],
            denyScopes: [Scope.Preview],
        },
        {
            path: AppRoute.PackagesToSignWithPolicyholderId,
            element: <PackagesToSignPage />,
            breadcrumb: fakeI18n.t("BreadCrumbs.Pages_Documentstosign"),
            allowScopes: [Scope.SignPackages],
            denyScopes: [Scope.Preview],
        },
        {
            path: AppRoute.DataVerification,
            element: <PolicyHolderList />,
            breadcrumb: fakeI18n.t("Breadcrumbs.DataVerification"),
            denyScopes: [Scope.Preview],
        },
        {
            path: AppRoute.DataVerificationCompany,
            element: <PolicyHolderList />,
            breadcrumb: fakeI18n.t("Breadcrumbs.Company"),
            denyScopes: [Scope.Preview],
        },
        {
            path: AppRoute.DataVerificationCompanyDetail,
            element: <DataVerificationCompany />,
            allowScopes: [Scope.DataVerificationCompany],
        },
    ];
};
